import { getMetaAdListQueryVariables } from '../../pages/HomeRoute'
import { Button } from '@mui/material'
import { graphql } from 'relay-runtime'
import { useFragment, useMutation } from 'react-relay'
import { HomeAction$key } from './__generated__/HomeAction.graphql'
import { toast } from 'react-toastify'
import { HomeActionCreateInMetaMutation } from './__generated__/HomeActionCreateInMetaMutation.graphql'
import styled from '@emotion/styled'
import { useAppDispatch } from '../../state/hooks'
import { setSubmitCreativeForApprovalConfirmDialog } from '../../state/appSlice'
import { useSelectedIdsList } from '../../components/SelectableItemList/context'
import { HomeListType, useTypeParam } from '../../state/url/type'

interface HomeActionProps {
  className?: string
  fragmentRequest: HomeAction$key
}

export const homeActionFragment = graphql`
  fragment HomeAction on Brand {
    id
    draftMetaAdCount
    approvedMetaAdCount
  }
`

export const homeActionCreateInMetaMutation = graphql`
  mutation HomeActionCreateInMetaMutation(
    $input: GetRequest!
    $metaAdsFilter: MetaAdsFilter
    $adIds: [String!]
  ) {
    createAdsInMeta(
      input: $input
      metaAdsFilter: $metaAdsFilter
      adIds: $adIds
    ) {
      id
      approvedMetaAdCount
      createdMetaAdCount
      ...CreativeList
      ...HomeAction
    }
  }
`

const S = {
  Wrapper: styled.div`
    width: 14rem;
    display: flex;
    justify-content: right;
  `,
  SubmitForApprovalButton: styled(Button)`
    font-size: 1rem;
  `,
}

const HomeAction = ({ className, fragmentRequest }: HomeActionProps) => {
  const brand = useFragment(homeActionFragment, fragmentRequest)
  const [createAdsInMetaRequest, createAdsInMetaLoading] =
    useMutation<HomeActionCreateInMetaMutation>(homeActionCreateInMetaMutation)
  const [type] = useTypeParam()
  const dispatch = useAppDispatch()
  const selectedIds = useSelectedIdsList()
  const selectionCount = selectedIds.length

  let button
  if (type === HomeListType.DRAFT) {
    const submitForApprovalDialog = () =>
      dispatch(setSubmitCreativeForApprovalConfirmDialog({ open: true }))
    button = (
      <S.SubmitForApprovalButton
        disabled={selectionCount === 0}
        onClick={submitForApprovalDialog}
        variant="contained"
      >
        Submit for Approval {!!selectionCount && `(${selectionCount})`}
      </S.SubmitForApprovalButton>
    )
  } else if (type === HomeListType.APPROVED) {
    const createInMeta = () => {
      const onCompleted = () => {
        toast.success(
          `Creating ads in Meta. They will appear over the course of the next few minutes...`
        )
      }
      const onError = (error: Error) => {
        console.log(error)
        const message = error.message.includes('deleted')
          ? error.message.slice(
              error.message.indexOf(':') + 1,
              error.message.length
            )
          : error.message
        toast.error(`Unable to create ads in Meta: ${message}`)
      }
      createAdsInMetaRequest({
        variables: {
          input: {
            id: brand.id,
          },
          adIds: selectedIds,
          ...getMetaAdListQueryVariables(type),
        },
        onCompleted,
        onError,
      })
    }
    button = (
      <Button
        disabled={selectionCount === 0 || createAdsInMetaLoading}
        onClick={createInMeta}
        variant="contained"
      >
        Create in Meta {!!selectionCount && `(${selectionCount})`}
      </Button>
    )
  }

  return <S.Wrapper className={className}>{button}</S.Wrapper>
}

export default HomeAction
